import { CurrencyPipe } from '@techrules/pipelib';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AppConfig } from '@tech-utils/app-config.service';
import { CommonService } from './common.service';
import { SessionService } from './session.service';
import {
  CompletedataService as sdkService,
  ClientData,
  InitcontributionService,
} from '@techrules/portallib';

@Injectable({
  providedIn: 'root',
})
export class CompletedataService {
  private http: HttpClient;
  public progressSource = new BehaviorSubject<number>(0);
  public progress$ = this.progressSource.asObservable();
  public stepsSource = new BehaviorSubject<number>(0);
  public steps$ = this.stepsSource.asObservable();
  public clientNameSource = new BehaviorSubject<string>('');
  public clientName$ = this.clientNameSource.asObservable();
  public clientSurnamesSource = new BehaviorSubject<string>('');
  public clientSurnames$ = this.clientSurnamesSource.asObservable();
  public showYouEmploymentSource = new BehaviorSubject<boolean>(false);
  public showYouEmployment$ = this.showYouEmploymentSource.asObservable();
  public incomeHasBeenSelectedSource = new BehaviorSubject<boolean>(true);
  public incomeHasBeenSelected$ =
    this.incomeHasBeenSelectedSource.asObservable();
  public percentageOkSource = new BehaviorSubject<boolean>(false);
  public percentageOk$ = this.percentageOkSource.asObservable();
  public hasTickersSource = new BehaviorSubject<boolean>(true);
  public hasTickers$ = this.hasTickersSource.asObservable();
  public hasTickersControlSource = new BehaviorSubject<boolean>(true);
  public hasTickersControl$ = this.hasTickersControlSource.asObservable();
  public hasTickersEmployeeSource = new BehaviorSubject<boolean>(true);
  public hasTickersEmployee$ = this.hasTickersEmployeeSource.asObservable();
  public isAccountHolderSource = new BehaviorSubject<any>(false);
  public isAccountHolder$ = this.isAccountHolderSource.asObservable();
  public isAccountHolderEmployeeSource = new BehaviorSubject<any>(false);
  public isAccountHolderEmployee$ =
    this.isAccountHolderEmployeeSource.asObservable();
  public isAccountHolderControlSource = new BehaviorSubject<any>(false);
  public isAccountHolderControl$ =
    this.isAccountHolderControlSource.asObservable();
  public listTickersSource = new BehaviorSubject<any>({} as any);
  public listTickers$ = this.listTickersSource.asObservable();
  public listTickersControlSource = new BehaviorSubject<any>({} as any);
  public listTickersControl$ = this.listTickersControlSource.asObservable();
  public listTickersEmployeeSource = new BehaviorSubject<any>({} as any);
  public listTickersEmployee$ = this.listTickersEmployeeSource.asObservable();
  public isAffiliateSource = new BehaviorSubject<boolean>(true);
  public isAffiliate$ = this.isAffiliateSource.asObservable();
  public isAffiliateSwichSource = new BehaviorSubject<boolean>(false);
  public isAffiliateSwich$ = this.isAffiliateSwichSource.asObservable();
  public LoadAffiliateSource = new BehaviorSubject<boolean>(false);
  public LoadAffiliate$ = this.LoadAffiliateSource.asObservable();
  public LoadSelfSource = new BehaviorSubject<boolean>(false);
  public LoadSelf$ = this.LoadSelfSource.asObservable();
  public anvDocOkSource = new BehaviorSubject<boolean>(false);
  public anvDocOk$ = this.anvDocOkSource.asObservable();
  public revDocOkSource = new BehaviorSubject<boolean>(false);
  public revDocOk$ = this.revDocOkSource.asObservable();
  public addressDocOkSource = new BehaviorSubject<boolean>(false);
  public addressDocOk$ = this.addressDocOkSource.asObservable();
  public incomeDocOkSource = new BehaviorSubject<boolean>(false);
  public incomeDocOk$ = this.incomeDocOkSource.asObservable();
  public countrySource = new BehaviorSubject<boolean>(false);
  public country$ = this.countrySource.asObservable();
  public countryOfIssueSource = new BehaviorSubject<boolean>(false);
  public countryOfIssue$ = this.countryOfIssueSource.asObservable();
  public necessaryDocsSource = new BehaviorSubject<any>({} as any);
  public necessaryDocs$ = this.necessaryDocsSource.asObservable();
  public natureBusinessSource = new BehaviorSubject<string>('');
  public natureBusiness$ = this.natureBusinessSource.asObservable();
  public occupationSource = new BehaviorSubject<string>('');
  public occupation$ = this.occupationSource.asObservable();
  public sectorSource = new BehaviorSubject<string>('');
  public sector$ = this.sectorSource.asObservable();
  public incomesSelectedSources = new BehaviorSubject<any>({} as any);
  public incomesSelected$ = this.incomesSelectedSources.asObservable();
  public investobjectivesSources = new BehaviorSubject<any>({} as any);
  public investobjectives$ = this.investobjectivesSources.asObservable();
  public fundingDataSources = new BehaviorSubject<any>({} as any);
  public fundingData$ = this.fundingDataSources.asObservable();
  public currencyDataSources = new BehaviorSubject<any>({} as any);
  public currencyData$ = this.currencyDataSources.asObservable();
  public signOKSources = new BehaviorSubject<boolean>(false);
  public signOK$ = this.signOKSources.asObservable();
  public worthErrorSources = new BehaviorSubject<boolean>(false);
  public worthError$ = this.worthErrorSources.asObservable();
  public liquidWorthErrorSources = new BehaviorSubject<boolean>(false);
  public liquidWorthError$ = this.liquidWorthErrorSources.asObservable();
  public attAffiliationSource = new BehaviorSubject<boolean>(false);
  public attAffiliation$ = this.attAffiliationSource.asObservable();
  public errorInvestExpeSource = new BehaviorSubject<boolean>(false);
  public errorInvestExpe$ = this.errorInvestExpeSource.asObservable();
  public errorAddressLineSource = new BehaviorSubject<boolean>(false);
  public errorAddressLine$ = this.errorAddressLineSource.asObservable();
  public isEmployedOrSelfSource = new BehaviorSubject<boolean>(false);
  public isEmployedOrSelf$ = this.isEmployedOrSelfSource.asObservable();
  public errorCheckSwitchIsUsedSource = new BehaviorSubject<boolean>(false);
  public errorCheckSwitchIsUsed$ =
    this.errorCheckSwitchIsUsedSource.asObservable();
  public errorRegExpAdressSource = new BehaviorSubject<boolean>(false);
  public errorRegExpAdress$ = this.errorRegExpAdressSource.asObservable();
  public errorRegExpAdressPostalSource = new BehaviorSubject<boolean>(false);
  public errorRegExpAdressPostal$ =
    this.errorRegExpAdressPostalSource.asObservable();
  public errorIsPorcentageZeroSource = new BehaviorSubject<boolean>(false);
  public errorIsPorcentageZero$ =
    this.errorIsPorcentageZeroSource.asObservable();
  public errorSelectCountrySource = new BehaviorSubject<boolean>(false);
  public errorSelectCountry$ = this.errorSelectCountrySource.asObservable();
  public errorSelectPaymentMethodSource = new BehaviorSubject<boolean>(false);
  public errorSelectPaymentMethod$ =
    this.errorSelectPaymentMethodSource.asObservable();
  public errorSelectFrequencySource = new BehaviorSubject<boolean>(false);
  public errorSelectFrequency$ = this.errorSelectFrequencySource.asObservable();
  public errorIdentificationNumberSource = new BehaviorSubject<boolean>(false);
  public errorIdentificationNumber$ =
    this.errorIdentificationNumberSource.asObservable();
  public errorTaxNumberSource = new BehaviorSubject<boolean>(false);
  public errorTaxNumber$ = this.errorTaxNumberSource.asObservable();
  public showReasonSource = new BehaviorSubject<boolean>(false);
  public showReason$ = this.showReasonSource.asObservable();
  public errorMinimunSource = new BehaviorSubject<boolean>(false);
  public errorMinimun$ = this.errorMinimunSource.asObservable();
  public errorRegExpMailSource = new BehaviorSubject<boolean>(false);
  public errorRegExpMail$ = this.errorRegExpMailSource.asObservable();
  public errorNameLettersSource = new BehaviorSubject<boolean>(false);
  public errorNameLetters$ = this.errorNameLettersSource.asObservable();
  public errorSurnameLettersSource = new BehaviorSubject<boolean>(false);
  public errorSurnameLetters$ = this.errorSurnameLettersSource.asObservable();
  public errorDocInvalid1Source = new BehaviorSubject<boolean>(false);
  public errorDocInvalid1$ = this.errorDocInvalid1Source.asObservable();
  public errorDocInvalid2Source = new BehaviorSubject<boolean>(false);
  public errorDocInvalid2$ = this.errorDocInvalid2Source.asObservable();
  public errorMaxFileSize1Source = new BehaviorSubject<boolean>(false);
  public errorMaxFileSize1$ = this.errorMaxFileSize1Source.asObservable();
  public errorMaxFileSize2Source = new BehaviorSubject<boolean>(false);
  public errorMaxFileSize2$ = this.errorMaxFileSize2Source.asObservable();
  public errorDocInvalidAddresSource = new BehaviorSubject<boolean>(false);
  public errorDocInvalidAddres$ =
    this.errorDocInvalidAddresSource.asObservable();
  public errorMaxFileSizeAddresSource = new BehaviorSubject<boolean>(false);
  public errorMaxFileSizeAddres$ =
    this.errorMaxFileSizeAddresSource.asObservable();
  public errorDocInvalidIncomeSource = new BehaviorSubject<boolean>(false);
  public errorDocInvalidIncome$ =
    this.errorDocInvalidIncomeSource.asObservable();
  public errorMaxFileSizeIncomeSource = new BehaviorSubject<boolean>(false);
  public errorMaxFileSizeIncome$ =
    this.errorMaxFileSizeIncomeSource.asObservable();
  public notificationFinalizeSource = new BehaviorSubject<boolean>(false);
  public notificationFinalize$ = this.notificationFinalizeSource.asObservable();
  public editDocSource = new BehaviorSubject<boolean>(false);
  public editDoc$ = this.editDocSource.asObservable();
  public showProcessSource = new BehaviorSubject<boolean>(true);
  public showProcess$ = this.showProcessSource.asObservable();
  public showFatcaSource = new BehaviorSubject<boolean>(true);
  public showFatca$ = this.showFatcaSource.asObservable();
  public showFormSource = new BehaviorSubject<string>('');
  public showForm$ = this.showFormSource.asObservable();
  public tDocumentSource = new BehaviorSubject<string>('');
  public tDocument$ = this.tDocumentSource.asObservable();
  public showYourFatcaSource = new BehaviorSubject<boolean>(false);
  public showYourFatca$ = this.showYourFatcaSource.asObservable();
  public hasDocumentsProofAddressSource = new BehaviorSubject<boolean>(false);
  public hasDocumentsProofAddress$ =
    this.hasDocumentsProofAddressSource.asObservable();
  public hasDocumentsIdentifidocSource = new BehaviorSubject<boolean>(false);
  public hasDocumentsIdentifidoc$ =
    this.hasDocumentsIdentifidocSource.asObservable();
  public hasDocumentsIncomedocSource = new BehaviorSubject<boolean>(false);
  public hasDocumentsIncomedoc$ =
    this.hasDocumentsIncomedocSource.asObservable();
  public employmentSituationSource = new BehaviorSubject<string>('');
  public employmentSituation$ = this.employmentSituationSource.asObservable();
  public showReasonsSource = new BehaviorSubject<boolean>(false);
  public showReasons$ = this.showReasonsSource.asObservable();
  public awareAndAgreeSource = new BehaviorSubject<boolean>(false);
  public awareAndAgree$ = this.awareAndAgreeSource.asObservable();
  public showPostalAddressSource = new BehaviorSubject<boolean>(false);
  public showPostalAddress$ = this.showPostalAddressSource.asObservable();
  public changeCheckedSource = new BehaviorSubject<boolean>(false);
  public changeChecked$ = this.changeCheckedSource.asObservable();
  public showOnboardingStatusSource = new BehaviorSubject<string>('');
  public showOnboardingStatus$ = this.showOnboardingStatusSource.asObservable();
  public imagesSelectedListSource = new BehaviorSubject<string>('');
  public imagesSelectedList$ = this.imagesSelectedListSource.asObservable();
  public cleanIncomeSource = new BehaviorSubject<boolean>(false);
  public cleanIncome$ = this.cleanIncomeSource.asObservable();
  public imageProofIncomeSource = new BehaviorSubject<boolean>(false);
  public imageProofIncome$ = this.imageProofIncomeSource.asObservable();
  public editImageProofIncomeSource = new BehaviorSubject<boolean>(false);
  public editImageProofIncome$ = this.editImageProofIncomeSource.asObservable();

  constructor(
    private httpBackend: HttpBackend,
    private commonService: CommonService,
    private session: SessionService,
    private initcontributionService: InitcontributionService,
    private sdkSvc: sdkService,
    private currencyPipe: CurrencyPipe
  ) {}

  public getEnumeration(enumerationType: string, parametre?: string) {
    return this.sdkSvc.getEnumeration(enumerationType, parametre).pipe(
      map((res) => {
        return res;
      }),
      catchError((err) => {
        this.commonService.errorManager('get_Enumeration', err);
        return throwError(err);
      })
    );
  }

  public getFullClientData() {
    return this.sdkSvc.getFullClientData().pipe(
      map((res) => {
        return res;
      }),
      catchError((err) => {
        this.commonService.errorManager('get_FullClientData', err);
        return throwError(err);
      })
    );
  }

  public setFullClientData(fullclientdata: ClientData) {
    return this.sdkSvc.setFullClientData(fullclientdata).pipe(
      map((res) => {
        return res;
      }),
      catchError((err) => {
        this.commonService.errorManager('set_FullClientData', err);
        return throwError(err);
      })
    );
  }

  public getWhatLegalDocuments() {
    return this.sdkSvc.getWhatLegalDocuments().pipe(
      map((res) => {
        return res;
      }),
      catchError((err) => {
        this.commonService.errorManager('apirest_get_what_legaldocuments', err);
        return throwError(err);
      })
    );
  }

  public uploadDocument(file: any, typeId: string) {
    return this.sdkSvc.uploadDocument(file, typeId).pipe(
      map((res) => {
        return res;
      }),
      catchError((err) => {
        this.commonService.loading$.emit(false);
        this.commonService.errorManager('apirest_upload_document', err);
        return throwError(err);
      })
    );
  }

  public allUploadDocuments(file: any, typeId: string) {
    return this.sdkSvc.allUploadDocuments(file, typeId).pipe(
      map((res) => {
        return res;
      }),
      catchError((err) => {
        this.commonService.loading$.emit(false);
        this.commonService.errorManager('apirest_upload_document', err);
        return throwError(err);
      })
    );
  }

  public uploadDocumentProofAddress(file: any) {
    return this.sdkSvc.uploadDocumentProofAddress(file).pipe(
      map((res) => {
        return res;
      }),
      catchError((err) => {
        this.commonService.errorManager(
          'apirest_upload_document_proofAddress',
          err
        );
        return throwError(err);
      })
    );
  }

  public setStep(step: string) {
    return this.sdkSvc
      .setStep(step, localStorage.getItem('portfolioCode'))
      .pipe(
        map((res) => {
          return res;
        }),
        catchError((err) => {
          this.commonService.errorManager('set_Step', err);
          return throwError(err);
        })
      );
  }

  public getFinancialPlanRefData() {
    return this.sdkSvc.getFinancialPlanRefData().pipe(
      map((res) => {
        return res;
      }),
      catchError((err) => {
        this.commonService.loading$.emit(false);
        this.commonService.errorManager('apirest_eval_refdata', err);
        return throwError(err);
      })
    );
  }

  public setIncomesAndWorths(data: any) {
    data.forEach((element, index, array) => {
      let elementSplit = element.Description.split(',');
      if (index == array.length - 1)
        element.Description =
          '> ' +
          this.currencyPipe.transform(
            elementSplit[0],
            AppConfig.settings.currencySymbolBase,
            '1.0-0'
          );
      else
        element.Description =
          this.currencyPipe.transform(
            elementSplit[0],
            AppConfig.settings.currencySymbolBase,
            '1.0-0'
          ) +
          ' - ' +
          this.currencyPipe.transform(
            elementSplit[1],
            AppConfig.settings.currencySymbolBase,
            '1.0-0'
          );
    });
    return data;
  }

  public funding(
    cashAmount: string,
    currency: string,
    bankname: string,
    modelPortfolioCode: string,
    exoneration: string,
    payeeDeliveryCode: string
  ) {
    return this.sdkSvc
      .funding(
        cashAmount,
        currency,
        bankname,
        modelPortfolioCode,
        exoneration,
        payeeDeliveryCode,
        localStorage.getItem('portfolioCode')
      )
      .pipe(
        map((res) => {
          return res;
        }),
        catchError((err) => {
          this.commonService.loading$.emit(false);
          this.commonService.errorManager('funding', err);
          return throwError(err);
        })
      );
  }

  public getFunding() {
    return this.sdkSvc.getFunding(localStorage.getItem('portfolioCode')).pipe(
      map((res) => {
        return res;
      }),
      catchError((err) => {
        this.commonService.errorManager('get_Funding', err);
        return throwError(err);
      })
    );
  }

  public getPendingTaskIb() {
    return this.sdkSvc
      .getPendingTaskIb(localStorage.getItem('portfolioCode'))
      .pipe(
        map((res) => {
          return res;
        }),
        catchError((err) => {
          this.commonService.errorManager('get_PendingTask_Ib', err);
          return throwError(err);
        })
      );
  }

  public getModelPortfolio(modelPortfolioCode: string) {
    return this.initcontributionService
      .getModelPortfolio(modelPortfolioCode)
      .pipe(
        map((res) => {
          localStorage.setItem('SessionClientToken', this.session.sessionToken);
          return res;
        }),
        catchError((err) => {
          this.commonService.loading$.emit(false);
          this.commonService.errorManager('apirest_minimun', err);
          return throwError(err);
        })
      );
  }

  public getCurrencies() {
    return this.initcontributionService.getCurrencies().pipe(
      map((res) => {
        localStorage.setItem('SessionClientToken', this.session.sessionToken);
        return res;
      }),
      catchError((err) => {
        this.commonService.loading$.emit(false);
        this.commonService.errorManager('getCurrencies', err);
        return throwError(err);
      })
    );
  }

  public getCustodioDoc(id?: string) {
    return this.sdkSvc.getCustodioDoc(AppConfig.settings.custodian, id).pipe(
      map((res) => {
        return res;
      }),
      catchError((err) => {
        this.commonService.errorManager('get_custodioDoc', err);
        return throwError(err);
      })
    );
  }

  public getContractDoc(portfoliocode?: string) {
    return this.sdkSvc.getContractDoc(portfoliocode).pipe(
      map((res) => {
        return res;
      }),
      catchError((err) => {
        this.commonService.errorManager('get_contractDoc', err);
        return throwError(err);
      })
    );
  }

  public getPortfolioSign(portfoliocode?: string) {
    return this.sdkSvc.getPortfolioSign(portfoliocode).pipe(
      map((res) => {
        return res;
      }),
      catchError((err) => {
        this.commonService.errorManager('get_contractSign', err);
        return throwError(err);
      })
    );
  }

  public getExonerationDoc(portfoliocode?: string) {
    return this.sdkSvc.getExonerationDoc(portfoliocode).pipe(
      map((res) => {
        return res;
      }),
      catchError((err) => {
        this.commonService.errorManager('get_exonerationDoc', err);
        this.commonService.isnotloading();
        return throwError(err);
      })
    );
  }

  public getPortfolioData(portfolioCode: string) {
    return this.sdkSvc.getPortfolioData(portfolioCode).pipe(
      map((res) => {
        return res;
      }),
      catchError((err) => {
        this.commonService.errorManager('get_portfolioData', err);
        return throwError(err);
      })
    );
  }

  public finalizeOnboarding(signature: string) {
    return this.sdkSvc
      .finalizeOnboarding(signature, localStorage.getItem('portfolioCode'))
      .pipe(
        map((res) => {
          return res;
        }),
        catchError((err) => {
          this.commonService.loading$.emit(false);
          this.notificationFinalizeSource.next(false);
          this.commonService.errorManager('apirest_finalize_onboarding', err);
          return throwError(err);
        })
      );
  }
}
